import { Fragment } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import setIn from 'transmute/setIn';
import { ChannelTypes } from 'conversations-internal-schema/constants/ChannelTypes';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Flex } from 'foundations-components/components/Flex';
import { LockBadge } from 'foundations-components/transitional/components/LockBadge';
import { Small } from 'foundations-components/transitional/components/Small';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useObjectDefinition } from '../../shared/hooks/useObjectDefinition';
import { checkIsRoutingRuleConfig } from '../operators/routingRulesGetters';
import { getAssignByAvailability } from '../utils/getAssignByAvailability';
import RuleBox from './RuleBox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const checkIsAssignableChannel = (channelType = '') => [ChannelTypes.EMAIL, ChannelTypes.FORMS, ChannelTypes.CHAT, false].includes(channelType);
const checkIsReadOnlyChannel = (channelType = '') => ChannelTypes.CHAT === channelType;
const AssignToAvailableUpgrade = ({
  show
}) => {
  if (!show) {
    return null;
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    placement: "right",
    title:
    /*#__PURE__*/
    // TODO: also disable for users that can assign to available but are not admins
    _jsx(FormattedMessage, {
      message: "routing-ui.routingRules.filterAvailableCheckbox.upgrade"
    }),
    children: /*#__PURE__*/_jsx(LockBadge, {
      marginInlineStart: "200"
    })
  });
};
AssignToAvailableUpgrade.displayName = 'AssignToAvailableUpgrade';
const AssignToAvailableDescription = ({
  objectTypeId
}) => {
  const {
    loading,
    objectDefinition
  } = useObjectDefinition(objectTypeId);
  if (loading) {
    return null;
  }
  if (!objectDefinition) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "routing-ui.routingRules.filterAvailableCheckbox.description"
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "routing-ui.routingRules.filterAvailableCheckbox.descriptionObjectType",
    options: {
      objectTypeName: objectDefinition.pluralForm
    }
  });
};
AssignToAvailableDescription.displayName = 'AssignToAvailableObjectDescription';
const AssignToAvailableCheckbox = ({
  channelType,
  disabled,
  hasAssignToAvailable = true,
  hideHeader,
  HeaderWrapper = Fragment,
  objectTypeId,
  onRuleUpdate,
  routingRules
}) => {
  const showAssignByAvailability = checkIsAssignableChannel(channelType) && checkIsRoutingRuleConfig(routingRules);
  if (!showAssignByAvailability) {
    return null;
  }
  const readOnly = checkIsReadOnlyChannel(channelType);
  return /*#__PURE__*/_jsx(RuleBox, {
    label: hideHeader ? null : /*#__PURE__*/_jsx(HeaderWrapper, {
      children: I18n.text('routing-ui.routingRules.filterAvailableCheckbox.title')
    }),
    children: /*#__PURE__*/_jsx(Tooltip, {
      disabled: !readOnly,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "routing-ui.routingRules.filterAvailableCheckbox.tooltip"
      }),
      children: /*#__PURE__*/_jsx(Flex, {
        inlineSize: "fit-content",
        children: /*#__PURE__*/_jsxs(Checkbox, {
          checked: getAssignByAvailability(routingRules),
          "data-test-id": "routing-assign-availability-checkbox",
          description: /*#__PURE__*/_jsx(Small, {
            use: "help",
            children: objectTypeId ? /*#__PURE__*/_jsx(AssignToAvailableDescription, {
              objectTypeId: objectTypeId
            }) : /*#__PURE__*/_jsx(FormattedMessage, {
              message: "routing-ui.routingRules.filterAvailableCheckbox.description"
            })
          }),
          disabled: !hasAssignToAvailable || disabled,
          onChange: ({
            target: {
              checked
            }
          }) => {
            onRuleUpdate(setIn(['shouldFilterToAvailable'], checked, routingRules));
          },
          readOnly: readOnly,
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "routing-ui.routingRules.filterAvailableCheckbox.label"
          }), /*#__PURE__*/_jsx(AssignToAvailableUpgrade, {
            show: !hasAssignToAvailable
          })]
        })
      })
    })
  });
};
AssignToAvailableCheckbox.displayName = 'AssignToAvailableCheckbox';
export default AssignToAvailableCheckbox;